import React from 'react';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import { removeAccentsAndUpperCase } from '../../common/logics';
import {
  GET_ALL_ENTITIES,
  GET_ALL_ENTITIES_FOR_USERS,
} from '../../graphql/entity/query';
import { GET_ALL_ECHELONS } from '../../graphql/echelon/query';
import {
  GetAllEchelons,
  GetAllEchelonsVariables,
} from '../../graphql/echelon/types/GetAllEchelons';
import { EchelonName } from '../../common/constants';
import { AllEntitiesInput } from '../../types/graphql-global-types';
import { useGetEnseign } from './useEnseign';
import {
  AllEntities,
  AllEntitiesVariables,
} from '../../graphql/entity/types/AllEntities';

export const useGetAllEntities = (variables: AllEntitiesVariables) => {
  return useQuery<AllEntities, AllEntitiesVariables>(GET_ALL_ENTITIES, {
    onError: (error) => console.log(error),
    variables,
  });
};

export const useLazyGetAllEntities = (input?: AllEntitiesInput) => {
  return useLazyQuery<AllEntities, AllEntitiesVariables>(
    GET_ALL_ENTITIES_FOR_USERS,
    {
      variables: { input },
      onError: (error) => console.log(error),
      fetchPolicy: 'network-only',
    },
  );
};

export const useAutoCompleteEntities = (
  agencySearchValue: string,
  enseigneId: number,
) => {
  const [getEnseign, { data: enseignData }] = useGetEnseign();

  const [getEchelons, { data }] = useLazyQuery<
    GetAllEchelons,
    GetAllEchelonsVariables
  >(GET_ALL_ECHELONS, {
    fetchPolicy: 'network-only',
  });

  React.useEffect(() => {
    getEchelons();
    if (enseigneId > 0) {
      getEnseign({ variables: { input: { id: enseigneId } } });
    }
  }, [enseigneId]);

  const agency = data?.getAllEchelons?.find(
    (echelon) => echelon.name === EchelonName.AGENCES,
  );

  const connectCreditAgency = data?.getAllEchelons?.find(
    (echelon) => echelon.name === EchelonName.AGENCE_CONNECTCREDIT,
  );

  return useQuery<AllEntities, AllEntitiesVariables>(GET_ALL_ENTITIES, {
    variables: {
      input: {
        take: 10,
        where: {
          echelon: {
            priority: {
              equals:
                enseignData?.getEnseigne?.name === 'CONNECTCRÉDIT'
                  ? connectCreditAgency?.priority
                  : agency?.priority,
            },
          },
          enseignes: [{ idCC: enseigneId }],
          name: removeAccentsAndUpperCase(agencySearchValue),
        },
      },
    },
    onError: (error) => {
      if (error.graphQLErrors) {
        if (error.graphQLErrors.length) {
          console.log(
            'auto complete entities error',
            error.graphQLErrors[0].message,
          );
        }
      }
    },
    fetchPolicy: 'network-only',
  });
};
